var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYthead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3090_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6811 4.12353C15.5906 3.78313 15.4123 3.47247 15.1641 3.22263C14.9159 2.97279 14.6063 2.79253 14.2665 2.69989C13.0156 2.36353 8.01562 2.36353 8.01562 2.36353C8.01562 2.36353 3.01563 2.36353 1.76472 2.69989C1.42491 2.79253 1.1154 2.97279 0.86715 3.22263C0.618902 3.47247 0.440629 3.78313 0.35017 4.12353C0.015625 5.37989 0.015625 7.99989 0.015625 7.99989C0.015625 7.99989 0.015625 10.6199 0.35017 11.8763C0.440629 12.2166 0.618902 12.5273 0.86715 12.7771C1.1154 13.027 1.42491 13.2073 1.76472 13.2999C3.01563 13.6363 8.01562 13.6363 8.01562 13.6363C8.01562 13.6363 13.0156 13.6363 14.2665 13.2999C14.6063 13.2073 14.9159 13.027 15.1641 12.7771C15.4123 12.5273 15.5906 12.2166 15.6811 11.8763C16.0156 10.6199 16.0156 7.99989 16.0156 7.99989C16.0156 7.99989 16.0156 5.37989 15.6811 4.12353Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37939 10.379V5.62085L10.5612 7.99994L6.37939 10.379Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3090_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYthead);
export default __webpack_public_path__ + "static/media/ythead.253c6434724a83d3bdbc2d855c723e01.svg";
export { ForwardRef as ReactComponent };